/* ============================================================
   ÉKO '77 — PARALLAX BED (shared primitive)

   Port of the reference drift loop in assets/js/site.js: every
   [data-parallax] bed is translated on the Y axis by a percentage of its
   own height, scaled by how far its HOST section sits from the middle of
   the viewport. Amplitude comes from the attribute (default 6).

   Reference maths, kept exactly:
     centre = host.top + host.height / 2
     off    = (centre - vh / 2) / (vh / 2 + host.height / 2)   // -1 … 1
     y      = clamp(off, -1, 1) * amount                        // in %

   Added on top of the reference, because a Shopify theme needs it:
     • beds are re-collected on shopify:section:load / :unload / :reorder,
       so a section re-rendered by the theme editor keeps drifting;
     • the reduced-motion preference is watched live, not read once;
     • the script is idempotent — loading it from several sections at once
       still installs exactly one scroll listener.

   DO NOT copy this file into another section. Render
   snippets/x-parallax-bed.liquid and it arrives with it.
   ============================================================ */
(function () {
  'use strict';

  if (window.__xParallaxBed) return;
  window.__xParallaxBed = true;

  var DEFAULT_AMOUNT = 6;
  var MARGIN = 200; // px of slack before a bed is considered offscreen
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var beds = [];
  var ticking = false;
  var listening = false;

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  function collect() {
    beds = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  }

  function reset() {
    beds.forEach(function (bed) {
      bed.style.transform = '';
    });
  }

  function drift() {
    ticking = false;
    if (mq.matches) return;

    var vh = window.innerHeight;

    beds.forEach(function (bed) {
      var parent = bed.parentElement;
      if (!parent) return;

      var host = parent.getBoundingClientRect();
      if (host.bottom < -MARGIN || host.top > vh + MARGIN) return; // offscreen, skip

      var centre = host.top + host.height / 2;
      var off = (centre - vh / 2) / (vh / 2 + host.height / 2);
      var amount = parseFloat(bed.getAttribute('data-parallax'));
      if (!amount && amount !== 0) amount = DEFAULT_AMOUNT;

      bed.style.transform =
        'translate3d(0,' + (clamp(off, -1, 1) * amount).toFixed(2) + '%,0)';
    });
  }

  function onDrift() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(drift);
  }

  function listen() {
    if (listening) return;
    listening = true;
    window.addEventListener('scroll', onDrift, { passive: true });
    window.addEventListener('resize', onDrift, { passive: true });
  }

  function refresh() {
    collect();
    if (!beds.length) return;
    if (mq.matches) {
      reset();
      return;
    }
    listen();
    drift();
  }

  function onPreferenceChange() {
    if (mq.matches) reset();
    else refresh();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onPreferenceChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onPreferenceChange);
  }

  // theme editor: a re-rendered section brings new beds and drops old ones
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(
    function (evt) {
      document.addEventListener(evt, refresh);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
